import {
  buildDefaultLocalMapTranslationKey,
  IBuildType,
  IShow,
  LocalMapType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import { ENV_KEY_PREFIX } from "tools/localization/envKeyPrefix";

export const showLocalMapKey = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "showLocalMap"> | undefined
): string =>
  buildType?.showLocalMap?.translationKey ||
  show?.localMap?.showLocalMap?.translationKey ||
  buildDefaultLocalMapTranslationKey(ENV_KEY_PREFIX, LocalMapType.Show);

const localizeShow = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "showLocalMap"> | undefined,
  t: UseTranslateResult["t"]
) => t(showLocalMapKey(show, buildType), { count: 1 });

export default localizeShow;
